export const actions = {
  LOG_FETCH_USER: "fetchAssociatedUsers",
  LOG_FETCH_EVENT: "fetchEvents",
}
